module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hero', {
    attrs: {
      "content": _vm.heroContent
    },
    on: {
      "hamburger": _vm.hamburgerClicked
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('voters', {
    staticClass: "voters col-xs-12"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix topper"
  }, [_c('critic-quote', {
    staticClass: "col-xs-12 no-pad",
    attrs: {
      "criticSliderContent": _vm.criticSlider1
    }
  }), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix grid"
  }, [_c('production-quote', {
    staticClass: "col-xs-12 col-md-6 col-md-push-6 no-pad",
    attrs: {
      "id": "bestPictureProdQuote1",
      "prodQuote": _vm.productionQuote1
    }
  }), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix grid"
  }, [_c('production-quote', {
    staticClass: "col-xs-12 col-md-6 no-pad",
    attrs: {
      "id": "bestPictureProdQuote2",
      "prodQuote": _vm.productionQuote2
    }
  }), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('click-thru', {
    attrs: {
      "clickThru": _vm.clickThru
    },
    on: {
      "clickThru": _vm.nextCategory
    }
  }), _vm._v(" "), _c('social'), _vm._v(" "), _c('legal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-10 col-md-offset-1 video no-pad hideme"
  }, [_c('video', {
    staticClass: "video-js vjs-default-skin",
    attrs: {
      "controls": "",
      "preload": "none",
      "data-setup": "{\"fluid\": true}",
      "poster": "https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/ThreeBillboardsOutsideEbbingMissouri_108_HumorAndPathos_1080p_H264_1-01.jpg"
    }
  }, [_c('source', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/ThreeBillboardsOutsideEbbingMissouri_108_HumorAndPathos_1080p_H264_1.mp4",
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/video/upload/v1627840644/three-bb/video/ThreeBillboardsOutsideEbbingMissouri_108_HumorAndPathos_1080p_H264.webm",
      "type": "video/webm"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 col-md-pull-6 image hideme"
  }, [_c('img', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/image/upload/v1627839187/three-bb/best_picture_block_1.jpg",
      "alt": "Three Billboards"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6 image hideme"
  }, [_c('img', {
    attrs: {
      "src": "https://res.cloudinary.com/dwmmozjrb/image/upload/v1627839187/three-bb/best_picture_block_2.jpg",
      "alt": "Three Billboards"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-036bd991","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/categoryPages/BestPicture.vue
// module id = 220
// module chunks = 0